import { render, staticRenderFns } from "./AdvancedCustomerBalances.vue?vue&type=template&id=28795558&"
import script from "./AdvancedCustomerBalances.vue?vue&type=script&lang=js&"
export * from "./AdvancedCustomerBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports